<div class="app-container" [class.role-switching]="isRoleSwitching">
  <div class="role-switch-overlay" *ngIf="isRoleSwitching">
    <div class="role-switch-spinner">
      <div class="spinner"></div>
      <p>Switching role...</p>
    </div>
  </div>
  </div>
  <router-outlet></router-outlet>

